export const PAYMENTS_FILTERS_SETS = {
    activeSet: 'v2',
    customSets: [],
    staticSets: [
        {
            id: 'v1',
            name: 'last 30 days',
            fixed: true,
            filters: [{ name: 'Period', value: '{last30days}' }],
        },
        {
            id: 'v2',
            name: 'to post',
            fixed: true,
            filters: [{ name: 'Period', value: '{last30days}' }],
        },
    ],
};
